export const FEATURE_NAMESPACE = 'feature.shift-summary'
